<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    data: {
      name: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
    }
  },
  eta: number
}>();

</script>

<template>
  <StandardCard top-padding="0" bottom-padding="1">
    <div class="flex justify-between text-subtext w-full">
      <div class="flex gap-4">
        <GenericIcon :tooltip="t('command.ships.current.explore.tooltip')" type="cmd_search" class="hidden md:inline"/>
        <div>
          {{ t('command.ships.current.explore.exploring') }}
        </div>
      </div>
      <div class="flex-shrink-0 ps-2">
        {{ eta >= 500 ? '500+' : eta }} {{ t('command.ships.current.days') }}
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>